import React from "react";
import {
    Box,
    List,
    ListItem,
    ListItemText,
    Menu,
    MenuItem,
    MenuProps,
    alpha,
    styled,
} from "@mui/material";

const options = [
    "Day",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "30",
    "31",
];

const StyledMenu = styled((props) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
        }}
        transformOrigin={{
            vertical: "top",
            horizontal: "center",
        }}
        {...props}
    />
))(({ theme }) => ({
    "& .MuiPaper-root": {
        borderRadius: 8,
        marginTop: "5px",
        minWidth: "auto",
        color:
            theme.palette.mode === "light"
                ? "rgb(55, 65, 81)"
                : theme.palette.grey[300],
        boxShadow: "0px 0px 4px 1px rgba(0, 0, 0, 0.08)",
        "& .MuiMenu-list": {
            padding: "11px 0 !important",
            display: "grid",
            gridAutoFlow: "column",
            gridTemplateRows: "repeat(10,minmax(0,1fr))",
            width: "150px",
        },
        "& .MuiMenuItem-root": {
            fontWeight: "500",
            fontSize: "12px",
            color: "#7D7D7D",
            padding: "1px 3px",
            borderRadius: "5px",
            justifyContent: "center",
            position: "relative",
            "&::before": {
                content: "''",
                position: "absolute",
                right: "-1px",
                width: "1px",
                height: "100%",
                top: 0,
                background: "rgba(227, 227, 227,.5)",
            },
            "&.Mui-selected": {
                background: "transparent",
                position: "relative",
                "&::after": {
                    content: "''",
                    position: "absolute",
                    right: 0,
                    width: "calc(100% - 11px)",
                    height: "100%",
                    top: 0,
                    background: "#F3F3F3",
                    borderRadius: "5px",
                    left: 0,
                    margin: "0 auto",
                },
            },
            "&:first-child": {
                display: "none",
            },
            "&:hover": {
                color: "#4b4b4b",
                background: "transparent !important",
                "&::after": {
                    content: "''",
                    position: "absolute",
                    right: 0,
                    width: "calc(100% - 11px)",
                    height: "100%",
                    top: 0,
                    background: "#F3F3F3",
                    borderRadius: "5px",
                    left: 0,
                    margin: "0 auto",
                },
            },
            "&:active": {
                // background: '#F3F3F3',
                borderRadius: "5px",
            },
        },
    },
}));

const SelectDay = (props) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClickListItem = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuItemClick = (event, index) => {
        setAnchorEl(null);
        props.sendDataToParent({ day: index > 9 ? index : "0" + index });
        props.setDay(index);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    return (
        <>
            <List
                component="div"
                aria-label="Device settings"
                className="day_divlst"
            >
                <ListItem
                    key="lock-button"
                    id="lock-button"
                    aria-haspopup="listbox"
                    aria-controls="lock-menu"
                    aria-expanded={open ? "true" : undefined}
                    onClick={handleClickListItem}
                    className={
                        props?.value !== 0
                            ? "onFocus byDay "
                            : "selectCommon byDay"
                    }
                >
                    <ListItemText secondary={options[props?.value]} />
                </ListItem>
            </List>
            <StyledMenu
                id="lock-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    "aria-labelledby": "lock-button",
                    role: "listbox",
                }}
            >
                {options.map((option, index) => (
                    <MenuItem
                        key={option}
                        disabled={index === 0}
                        selected={index === props?.value}
                        onClick={(event) => handleMenuItemClick(event, index)}
                    >
                        <Box className="styledDay">{option}</Box>
                    </MenuItem>
                ))}
            </StyledMenu>
        </>
    );
};
export default SelectDay;
